import React from "react";

import {pluralize} from "@pg-mono/string-utils";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {flatsPluralize} from "../../../real_estate/constants/flats_pluralize";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {IRoomRange} from "./OfferDetailGeneratedDescription";
import {OfferDetailGeneratedDescriptionParkingPlaces} from "./OfferDetailGeneratedDescriptionParkingPlaces";
import {OfferDetailGeneratedDescriptionRoomRanges} from "./OfferDetailGeneratedDescriptionRoomRanges";
import {OfferDetailGeneratedDescriptionStorage} from "./OfferDetailGeneratedDescriptionStorage";
import {OfferGeneratedDescriptionTextFlats} from "./OfferGeneratedDescriptionTextFlats";

interface IProps {
    className?: string;
    offer: {
        currency: Currency;
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        stats: {
            all_flat_types: Record<string, number>;
            properties_count_for_sale: number;
            properties_count_mdm: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        type: number;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const OfferDetailGeneratedDescriptionFlat = ({offer}: IProps) => {
    // others
    const mdmCount = offer.stats?.properties_count_mdm;

    return (
        <>
            <OfferGeneratedDescriptionTextFlats offer={offer} />

            <OfferDetailGeneratedDescriptionRoomRanges header="Dostępne są mieszkania:" rooms_ranges={offer.stats?.rooms_ranges ?? []} type={offer.type} />

            {mdmCount ? (
                <p>
                    {`Aktualnie w inwestycji ${offer.name} w sprzedaży ${pluralize(["znajduje", "znajdują", "znajduje"])(
                        mdmCount
                    )} się ${mdmCount} ${flatsPluralize(mdmCount)}, które ${pluralize(["spełniało", "spełniały", "spełniały"])(mdmCount)} kryteria MDM 2018.`}
                </p>
            ) : null}

            <OfferDetailGeneratedDescriptionParkingPlaces investor={offer.investor} parking_places={offer.parking_places} vendor={offer.vendor} />

            <OfferDetailGeneratedDescriptionStorage storage={offer.storage} />
        </>
    );
};
import React from "react";

import {pluralize} from "@pg-mono/string-utils";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {flatsPluralize} from "../../../real_estate/constants/flats_pluralize";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {IRoomRange} from "./OfferDetailGeneratedDescription";
import {OfferDetailGeneratedDescriptionParkingPlaces} from "./OfferDetailGeneratedDescriptionParkingPlaces";
import {OfferDetailGeneratedDescriptionRoomRanges} from "./OfferDetailGeneratedDescriptionRoomRanges";
import {OfferDetailGeneratedDescriptionStorage} from "./OfferDetailGeneratedDescriptionStorage";
import {OfferGeneratedDescriptionTextFlats} from "./OfferGeneratedDescriptionTextFlats";

interface IProps {
    className?: string;
    offer: {
        currency: Currency;
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        stats: {
            all_flat_types: Record<string, number>;
            properties_count_for_sale: number;
            properties_count_mdm: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        type: number;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const OfferDetailGeneratedDescriptionFlat = ({offer}: IProps) => {
    // others
    const mdmCount = offer.stats?.properties_count_mdm;

    return (
        <>
            <OfferGeneratedDescriptionTextFlats offer={offer} />

            <OfferDetailGeneratedDescriptionRoomRanges header="Dostępne są mieszkania:" rooms_ranges={offer.stats?.rooms_ranges ?? []} type={offer.type} />

            {mdmCount ? (
                <p>
                    {`Aktualnie w inwestycji ${offer.name} w sprzedaży ${pluralize(["znajduje", "znajdują", "znajduje"])(
                        mdmCount
                    )} się ${mdmCount} ${flatsPluralize(mdmCount)}, które ${pluralize(["spełniało", "spełniały", "spełniały"])(mdmCount)} kryteria MDM 2018.`}
                </p>
            ) : null}

            <OfferDetailGeneratedDescriptionParkingPlaces investor={offer.investor} parking_places={offer.parking_places} vendor={offer.vendor} />

            <OfferDetailGeneratedDescriptionStorage storage={offer.storage} />
        </>
    );
};
